import {store} from 'store/main-store';
import {
    BUSCADOR_SET_MARCAS, 
    BUSCADOR_SET_MODELOS, 
    BUSCADOR_SET_LINEAS, 
    BUSCADOR_SET_VERSIONES
} from 'store/store-constants';
// import {GET_LINEAS, GET_MARCAS, GET_MODELOS, GET_VERSIONES} from "./api-constants";
import {API_MARCAS, API_MODELOS, API_LINEAS, API_VERSIONES, HEADERS} from 'providers/ApiCredentials';

export default {
    getMarcas() {
        axios.get(API_MARCAS, HEADERS).then(response => {
            const parsingMarcas = _.orderBy(
                response.data.marcas,
                ["name"],
                ["asc"]
            );
            store.commit(BUSCADOR_SET_MARCAS, parsingMarcas)
        });
    },
    getModelos(idMarca) {
        const data = {
            id_marca: idMarca
        };
        axios.post(API_MODELOS,data, HEADERS).then(response => {
            const parsingModelos = _.orderBy(
                response.data.modelos,
                ["modelo"],
                ["asc"]
            );
            store.commit(BUSCADOR_SET_MODELOS, parsingModelos)
        });
    },
    getLineas(idMarca, modelo) {
        const data = {
            id_marca: idMarca,
            modelo: modelo
        };
        axios.post(API_LINEAS,data, HEADERS).then(response => {
            const parsingLineas = _.orderBy(
                response.data.lineas,
                ["linea.name"],
                ["asc"]
            );
            store.commit(BUSCADOR_SET_LINEAS, parsingLineas)
        });
    },
    getVersiones(idLinea, modelo) {
        const data = {
            id_linea: idLinea,
            modelo: modelo
        };
        axios.post(API_VERSIONES,data, HEADERS).then(response => {
            const versiones = response.data.versiones;
            console.log(versiones);
            store.commit(BUSCADOR_SET_VERSIONES, versiones)
        });
    }
}
